module.exports = __webpack_public_path__ + "static/media/carta_47.bcef1764.jpg";